import store from "../app/store";
/**
 * Creates a new chatbot with a randomly selected name.
 *
 * - Makes a `POST` request to the backend server to create a new bot.
 * - The request includes an authorization token from Redux store.
 *
 * @async
 * @function CreateNewBot
 * @returns {Promise<{data: any, error: boolean, msg: string}>} - A promise that resolves to an object containing:
 * - `data`: The newly created bot object from the backend.
 * - `error`: `true` if an error occurred, otherwise `false`.
 * - `msg`: A message indicating the result of the operation.
 *
 * @example
 * const result = await CreateNewBot();
 * if (!result.error) {
 *   console.log("Bot created:", result.data);
 * } else {
 *   console.error("Failed to create bot:", result.msg);
 * }
 */

const botNames = [
  "ChatNova",
  "InfoGenie",
  "SwiftBot",
  "Askly",
  "NeoHelper",
  "Supporto",
  "Helpster",
  "BizBuddy",
  "TicketTitan",
  "CRMate",
  "KnowBot",
  "IntelliQ",
  "DataWhiz",
  "ScholarAI",
  "QueryMind",
  "MarketMate",
  "SEOlyzer",
  "FunnelFox",
  "AdGenie",
  "ClickBot",
  "MoodMate",
  "CalmBot",
  "FitTrack",
  "SleepyAI",
  "NutriBot",
];

const CreateNewBot = async () => {
  const domain = process.env.REACT_APP_SERVER;
  const url = `${domain}/bot/new`;

  const randomIndex = Math.floor(Math.random() * botNames.length);
  const randomName = botNames[randomIndex];

  const token = store.getState().auth.token;

  if (!token) {
    return { data: null, error: true, msg: "No token found" };
  }

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ name: randomName }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.msg || "Failed to create bot");
    }

    return {
      data: data?.data,
      error: false,
      msg: "Successfully Created New Bot",
    };
  } catch (err) {
    console.error("CreateNewBot Error:", err.message);
    return { data: null, error: true, msg: err.message };
  }
};

export default CreateNewBot;
